import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { Form, Checkbox, Header, Icon, Segment } from "semantic-ui-react";
import UserInput from "../UserInput";

const NUMBER_OF_CONFIGURABLE_SCANNERS = 5;

const TyreScannerInputPair = withTranslation()(({ isTyreScannerDisabled, serial_number, short_code, order, onChange, t }) => {
  return (
    <div className="TyreScannerInputPair">
      <div className="order">{`${order}. ${t("serial_number").message || "Serial Number"}`}</div>

      <Form.Field>
        <UserInput
          name="serial_number"
          disabled={isTyreScannerDisabled}
          value={serial_number}
          onChange={onChange}
          placeholder={t("enter_serial_number").message || "Enter Serial Number"}
        />
      </Form.Field>

      <Form.Field>
        <UserInput disabled={isTyreScannerDisabled} value={short_code} placeholder={t("enter_pairing_number").message || "Enter Pairing Number (1-5)"} />
      </Form.Field>
    </div>
  );
});

class TyreScannerConfiguration extends Component {
  constructor(props) {
    super(props);

    this.state = { aaEquipmentTyreScanners: this.handleSetUpAAEquipmentTyreScannersInitialData() };
  }

  handleSetUpAAEquipmentTyreScannersInitialData = () => {
    const { aa_equipment_tyre_scanners = [] } = this.props.location;

    if (aa_equipment_tyre_scanners.length === NUMBER_OF_CONFIGURABLE_SCANNERS) return aa_equipment_tyre_scanners;

    const aaEquipmentTyreScanners = [];

    for (let i = 1; i <= NUMBER_OF_CONFIGURABLE_SCANNERS; i++) {
      const scanner = aa_equipment_tyre_scanners.find(({ short_code }) => short_code === i);
      if (scanner) aaEquipmentTyreScanners.push(scanner);
      else aaEquipmentTyreScanners.push({ serial_number: "", short_code: i });
    }

    return aaEquipmentTyreScanners.sort((s1, s2) => s1.short_code - s2.short_code);
  };

  handleCheckboxChange = (_e, { name, checked }) => {
    const { location, onLocationChange } = this.props;

    onLocationChange({ ...location, [name]: checked });
  };

  handleInputChange = ({ name, value, order }) => {
    const { location, onLocationChange } = this.props;
    const { aaEquipmentTyreScanners } = this.state;

    const updatedAAEquipmentTyreScanners = aaEquipmentTyreScanners.map((scanner, idx) => (order === idx ? { ...scanner, [name]: value } : scanner));

    this.setState({ aaEquipmentTyreScanners: updatedAAEquipmentTyreScanners });
    onLocationChange({ ...location, aa_equipment_tyre_scanners: updatedAAEquipmentTyreScanners });
  };

  render() {
    const { location, t } = this.props;
    const { aaEquipmentTyreScanners } = this.state;

    return (
      <Segment>
        <Header as="h5">
          <Header.Content>{t("tire_scanner").message || "Tire Scanner"}</Header.Content>
        </Header>
        <Form.Field className="full-width-input">
          <Checkbox
            name="is_tire_scanner_enabled"
            checked={location.is_tire_scanner_enabled}
            onChange={this.handleCheckboxChange}
            label={t("tire_scanner").message || "Tire Scanner"}
          />
        </Form.Field>
        <Segment>
          <Header as="h5">
            <Icon name="signal" />
            <Header.Content>{t("aa_equipment_tire_scanner_pairing").message || "AAEquipment Tire Scanner Pairing"}</Header.Content>
          </Header>
          <Form>
            {aaEquipmentTyreScanners.map(({ serial_number, short_code }, idx) => (
              <TyreScannerInputPair
                key={idx}
                serial_number={serial_number}
                short_code={short_code}
                order={idx + 1}
                isTyreScannerDisabled={!location.is_tire_scanner_enabled}
                onChange={(_e, { name, value }) => this.handleInputChange({ name, value, order: idx })}
              />
            ))}
          </Form>
        </Segment>
      </Segment>
    );
  }
}

export default withTranslation()(TyreScannerConfiguration);
